export default {
  modelName: 'meeting_template_type',
  label: '議事模板類型',
  fields: {
    sequence: {
      type: 'text',
      label: '排序',
      maxlength: 10,
    },
    name: {
      label: '名稱',
      type: 'text',
      width: '300px',
      readonly: true,
    },
    value: {
      type: 'text',
      rules: 'required',
      label: 'value',
      width: '300px',
    },
    locales: {
      type: 'locales',
      fields: {
        name: {
          type: 'text',
          label: '名稱',
          width: '300px',
          rules: 'required',
          maxlength: 100,
        },
      },
    },
    is_active: {
      type: 'switch',
      label: '啟用',
      defaultValue: true,
    },
    updated_at: {
      type: 'datetime',
      label: '最後更新時間',
      readonly: true,
    },
    updated_admin: {
      type: 'belongsTo',
      label: '最後更新人',
      readonly: true,
      textKey: 'name',
      modeldataName: 'admin',
    },
  },
};
